import { render } from "./contactItem.vue?vue&type=template&id=4c2a6be8&scoped=true&ts=true"
import script from "./contactItem.vue?vue&type=script&lang=ts"
export * from "./contactItem.vue?vue&type=script&lang=ts"

import "./contactItem.vue?vue&type=style&index=0&id=4c2a6be8&scoped=true&lang=css"

import exportComponent from "/Users/zhaoliang/Desktop/vue3-webim/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2a6be8"]])

export default __exports__